module.exports = __webpack_public_path__ + "img/about7.888723b3.png";